<template>
  <div class="practice-detail container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="实战详情">
      </el-page-header>
      <el-button
        class="btn"
        type="primary"
        size="small"
        @click="
          $router.push({
            path: '/courseDetail/practice/uploadWorks',
            query: {
              ...$route.query,
              worksId: info.worksStatus == 'REDO' ? info.worksId : null,
            },
          })
        "
        :disabled="info.worksStatus == 'SUBMITTED'"
        >提交作品</el-button
      >
      <div class="main-area">
        <div class="ql-container ql-snow" style="border: none">
          <div class="ql-editor">
            <div v-html="info.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { practiceInfo } from "@/api/practice";

export default {
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.$loading.show();
    practiceInfo(this.$route.query.taskId).then((res) => {
      this.$loading.hide();
      if (res.code == 0) {
        this.info = res.data;
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.practice-detail {
  height: 100%;
  text-align: left;
  .box {
    position: relative;
    padding: 25px 0;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: #fff;

    ::v-deep .el-page-header {
      padding: 0 35px;
      margin-bottom: 20px;
      .el-page-header__content {
        font-size: 16px;
      }
    }
    .btn {
      position: absolute;
      top: 25px;
      right: 35px;
      width: 100px;
    }
    .main-area {
      height: calc(100% - 44px);
      .ql-editor {
        padding: 0 35px;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
      }
    }
  }
}
</style>